function handleSingleOption({ state, input, output }) {
  let field = state.get(input.field)
  let selectedOptions = [input.option]
  let filteredOptions = field.filteredOptions

  if (field.value.length > 0) {
    state.merge(`${input.field}.options.${field.value[0].index}`, {
      selected: false
    })
    if (filteredOptions) {
      for (let i = 0; i < filteredOptions.length; i++) {
        if (filteredOptions[i].key === field.value[0].key) {
          state.merge(`${input.field}.filteredOptions.${i}`, {
            selected: false
          })
          break
        }
      }
    }
  }
  state.set(`${input.field}.value`, selectedOptions)
  state.merge(`${input.field}.options.${input.option.index}`, {
    selected: true
  })
  if (filteredOptions) {
    state.merge(`${input.field}.filteredOptions.${input.option.filterIndex}`, {
      selected: true
    })
  }

  let populateOptionsForStatePath = state.get(
    `${input.field}.options.${input.option.index}.populateOptionsForStatePath`
  )

  if (populateOptionsForStatePath) {
    output.populate({ populateOptionsForStatePath })
  } else {
    output.notPopulate()
  }
}

handleSingleOption.outputs = ['populate', 'notPopulate']
export default handleSingleOption



// WEBPACK FOOTER //
// ./src/modules/client/actions/handleSingleOption.js